import type { MeetingPoint, MeetingPointPayloadData } from '../../types';

import { AxiosError } from 'axios';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { App } from 'antd';

import { axiosClient } from '@/lib/axios';
import { queryClient } from '@/lib/react-query';

type Payload = {
  companyID: number;
  meetingID: number;
  meetingPointID: number;
  body: MeetingPointPayloadData;
};

export const editMeetingPoint = async ({
  companyID,
  meetingID,
  meetingPointID,
  body,
}: Payload): Promise<{ data: MeetingPoint }> => {
  const { data } = await axiosClient.put<{ data: MeetingPoint }>(
    `/companies/${companyID}/meetings/${meetingID}/meeting-points/${meetingPointID}`,
    body,
  );

  return data;
};
type UseEditMeetingPointOptions = {
  config?: Partial<UseMutationOptions<{ data: MeetingPoint }, AxiosError<{ message: string }>, Payload>>;
  postSuccess?: () => void;
};

export const useEditMeetingPoint = ({ config, postSuccess }: UseEditMeetingPointOptions) => {
  const { notification: toaster } = App.useApp();
  return useMutation({
    onError: (error) => {
      toaster.error({
        message: 'Something Went Wrong',
        description: error.message,
      });
    },
    onSuccess: async (_, params) => {
      await queryClient.invalidateQueries({
        queryKey: ['meetings'],
      });
      await queryClient.invalidateQueries({
        queryKey: ['meeting-details', params.companyID],
      });
      await queryClient.invalidateQueries({
        queryKey: ['meeting-points'],
      });
      toaster.success({
        message: 'Updated Successfully',
        description: 'Meeting Point Updated Successfully',
      });
      postSuccess?.();
    },
    ...config,
    mutationFn: editMeetingPoint,
  });
};
